export class Reference {
	constructor(
		public readonly packageSize: number | null,
		public readonly referenceBasketVersion: string,
		public readonly referencedProductType: string,
		public readonly historicProductDataViewDate: Date | null,
		public readonly amountOfSubstanceInUnit: number | null
	) {}
}
